__turbopack_context__.v({
  "description": "TogglingFiltersFallback-module-scss-module__8Dyppq__description",
  "fallbackWrapper": "TogglingFiltersFallback-module-scss-module__8Dyppq__fallbackWrapper",
  "upgradePlanButton": "TogglingFiltersFallback-module-scss-module__8Dyppq__upgradePlanButton",
});
